var _defs, _rect, _g, _g2, _path, _circle, _path2, _circle2, _circle3, _g3, _g4, _g5, _path3, _circle4, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiMlIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 420",
    fill: "none",
    "aria-label": "Local AI and machine learning for industrial predictive maintenance, anomaly detection and forecasting",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradPurple",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6f55ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3bb0d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradOrange",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff6b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffb840"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradGreen",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#10b981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#34d399"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-10%",
    y: "-10%",
    width: "120%",
    height: "120%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 16,
    floodColor: "#0f172a",
    floodOpacity: 0.1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "over"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 560,
    height: 380,
    rx: 24,
    fill: "#fff",
    stroke: "#e7e7e7",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 220)",
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 140,
    rx: 14,
    fill: "#101621",
    stroke: "#2a3441",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 96,
    height: 116,
    rx: 8,
    fill: "#161f2c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 36,
    r: 6,
    fill: "#28c76f",
    className: "animate-pulse-slow"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 32,
    width: 46,
    height: 8,
    rx: 4,
    fill: "#2a3441"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 56,
    width: 68,
    height: 6,
    rx: 3,
    fill: "#2a3441"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 70,
    width: 52,
    height: 6,
    rx: 3,
    fill: "#2a3441"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 84,
    width: 60,
    height: 6,
    rx: 3,
    fill: "#2a3441"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 104,
    width: 68,
    height: 10,
    rx: 5,
    fill: "url(#gradPurple)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 156,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    textAnchor: "middle"
  }, "On-Premise AI"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 60)",
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 130,
    rx: 14,
    fill: "#fff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 65,
    r: 34,
    fill: "#f1f5f9",
    stroke: "#cbd5e1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 65,
    r: 24,
    fill: "none",
    stroke: "url(#gradOrange)",
    strokeWidth: 6,
    strokeDasharray: "100 40",
    className: "animate-rotate-slow"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 65,
    r: 10,
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 110,
    width: 68,
    height: 8,
    rx: 4,
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 146,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif",
    textAnchor: "middle"
  }, "Motor / Pump"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 190 L120 220",
    stroke: "url(#gradPurple)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "8 6",
    className: "animate-dash"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240, 140)",
    filter: "url(#glow)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 56,
    fill: "#fff",
    stroke: "url(#gradPurple)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18c-14 0-26 8-30 18-12 3-20 13-20 24 0 11 8 21 20 24 4 10 16 18 30 18s26-8 30-18c12-3 20-13 20-24 0-11-8-21-20-24-4-10-16-18-30-18z",
    fill: "url(#gradPurple)",
    className: "animate-pulse-slow"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 62,
    r: 14,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 62,
    r: 6,
    fill: "#6f55ff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 40,
    r: 4,
    fill: "#3bb0d7",
    className: "animate-pulse-slow",
    style: {
      animationDelay: "0.3s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 40,
    r: 4,
    fill: "#ff6b00",
    className: "animate-pulse-slow",
    style: {
      animationDelay: "0.6s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 85,
    r: 4,
    fill: "#ff6b00",
    className: "animate-pulse-slow",
    style: {
      animationDelay: "0.9s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 85,
    r: 4,
    fill: "#3bb0d7",
    className: "animate-pulse-slow",
    style: {
      animationDelay: "1.2s"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180 290 C200 290, 220 260, 260 230",
    stroke: "url(#gradPurple)",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round",
    strokeDasharray: "8 6",
    className: "animate-dash",
    style: {
      animationDelay: "0.5s"
    }
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(420, 60)",
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 90,
    rx: 12,
    fill: "#fff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 36,
    height: 36,
    rx: 10,
    fill: "#fff3e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 28v16M26 36h16",
    stroke: "#ff6b00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 34,
    fill: "#0f172a",
    fontSize: 13,
    fontWeight: 700,
    fontFamily: "Roboto, sans-serif"
  }, "Anomaly"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 52,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif"
  }, "LSTM autoencoder"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66,
    width: 108,
    height: 8,
    rx: 4,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66,
    width: 78,
    height: 8,
    rx: 4,
    fill: "url(#gradOrange)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(420, 165)",
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 90,
    rx: 12,
    fill: "#fff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 36,
    height: 36,
    rx: 10,
    fill: "#f0edff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 40h12M34 34v12",
    stroke: "#6f55ff",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 34,
    fill: "#0f172a",
    fontSize: 13,
    fontWeight: 700,
    fontFamily: "Roboto, sans-serif"
  }, "RUL"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 52,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif"
  }, "Remaining life"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66,
    width: 108,
    height: 8,
    rx: 4,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66,
    width: 92,
    height: 8,
    rx: 4,
    fill: "url(#gradPurple)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(420, 270)",
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 90,
    rx: 12,
    fill: "#fff",
    stroke: "#e2e8f0",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 36,
    height: 36,
    rx: 10,
    fill: "#ecfdf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 42 L34 34 L42 38 L50 26",
    stroke: "#10b981",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 34,
    fill: "#0f172a",
    fontSize: 13,
    fontWeight: 700,
    fontFamily: "Roboto, sans-serif"
  }, "Forecast"), /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 52,
    fill: "#64748b",
    fontSize: 11,
    fontFamily: "Roboto, sans-serif"
  }, "Sequence model"), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66,
    width: 108,
    height: 8,
    rx: 4,
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66,
    width: 64,
    height: 8,
    rx: 4,
    fill: "url(#gradGreen)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360 200 C390 200, 400 110, 420 105",
    stroke: "url(#gradOrange)",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeDasharray: "6 6",
    className: "animate-dash"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360 200 C390 200, 400 215, 420 215",
    stroke: "url(#gradPurple)",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeDasharray: "6 6",
    className: "animate-dash",
    style: {
      animationDelay: "0.4s"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360 200 C390 200, 400 320, 420 315",
    stroke: "url(#gradGreen)",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeDasharray: "6 6",
    className: "animate-dash",
    style: {
      animationDelay: "0.8s"
    }
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 120,
    r: 5,
    fill: "#6f55ff",
    className: "animate-float"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 300,
    r: 5,
    fill: "#ff6b00",
    className: "animate-float",
    style: {
      animationDelay: "0.5s"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 160,
    r: 5,
    fill: "#3bb0d7",
    className: "animate-float",
    style: {
      animationDelay: "1s"
    }
  }), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes float {\n      0%, 100% { transform: translateY(0); }\n      50% { transform: translateY(-12px); }\n    }\n    @keyframes pulse {\n      0%, 100% { opacity: 0.65; transform: scale(1); }\n      50% { opacity: 1; transform: scale(1.08); }\n    }\n    @keyframes dash {\n      to { stroke-dashoffset: 0; }\n    }\n    @keyframes rotate {\n      from { transform: rotate(0deg); }\n      to { transform: rotate(360deg); }\n    }\n    .animate-float { animation: float 5s ease-in-out infinite; }\n    .animate-pulse-slow { animation: pulse 3s ease-in-out infinite; transform-origin: center; }\n    .animate-dash { animation: dash 2s linear infinite; }\n    .animate-rotate-slow { animation: rotate 12s linear infinite; transform-origin: center; }\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMlIllustration);
export default __webpack_public_path__ + "static/media/ai_ml_illustration.3ff150e9400dc5bbceeb11241971adc9.svg";
export { ForwardRef as ReactComponent };